module.exports = __webpack_public_path__ + "img/3@2x.27495941.png";